<template>
  <div class="form-group">
    <label v-if="label" style="width: 100%">{{ label }}
      <span v-if="required" style="color: red; margin-top: 20px;"> *</span>
      <span v-if="validation?.$error" style="color: red; margin-top: 20px;">{{messages}}</span>
    </label>
    <label class="toggle_switch">
      <input
          :checked="modelValue"
          type="checkbox"
          @input="handleInput">
      <span class="toggle_slider rounded"></span>
    </label>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, toRefs } from "vue";

const props = defineProps({
  modelValue: {
    type: [String, Number, Boolean, null],
    required: true,
  },
  label: {
    type: [String, Boolean],
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  validation: {
    type: Object,
    default: () => ({}),
  },
  messages: {
    type: [Object, String, Array],
    default: () => ({}),
  },
  inputStyle: {
    type: Object,
  },
});

const emit = defineEmits(["update:modelValue"]);
const { modelValue } = toRefs(props);

const handleInput = (event) => {
  let inputValue = event.target.checked;
  emit("update:modelValue", inputValue);
};
</script>

<style scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 25px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e65252;
  transition: .4s;
  overflow: hidden;
  border-radius: 4px;
}

.slider:before {
  position: absolute;
  content: "Ja";
  height: 19px; /* Visina unutrašnjeg polja (25px - 6px margina) */
  width: 52px;  /* Širina prilagođena da stane unutra */
  left: -54px;  /* Sakriveno levo */
  bottom: 3px;
  background-color: #43ad4e;
  transition: .4s;
  border-radius: 3px;
  font-size: 11px;
  line-height: 19px;
  text-align: center;
  color: white;
  font-weight: bold;
}

.slider:after {
  position: absolute;
  content: "Nein";
  height: 19px;
  width: 52px;
  left: 4px;
  bottom: 3px;
  background-color: #e65252;
  transition: .4s;
  border-radius: 3px;
  font-size: 11px;
  line-height: 19px;
  text-align: center;
  color: white;
  font-weight: bold;
}

input:checked + .slider {
  background-color: #43ad4e;
}

/* Precizni pomak za širinu od 60px */
input:checked + .slider:before {
  transform: translateX(58px);
}

input:checked + .slider:after {
  transform: translateX(60px);
}
</style>
